import ProstheticsPrice from '../../entities/Price/ProstheticsPrice/ui/ProstheticsPrice';
import Prosthetics from '../../entities/Prosthetics/ui/Prosthetics';
import ProstheticsDesc from '../../entities/Prosthetics/ui/ProstheticsDesc';
import Footer from '../../widgets/Footer/ui/FooterContact/Footer';
import FooterInfo from '../../widgets/Footer/ui/FooterInfo/FooterInfo';
import HeaderProsthetic from '../../widgets/HeaderProsthetic/ui/HeaderProsthetic';
import styles from './ProstheticsPage.module.scss';

export const ProstheticsPage = () => {
    return(
        <div className={styles.prosthetic}>
            <HeaderProsthetic/>
            <Prosthetics/>
            <ProstheticsPrice/>
            <ProstheticsDesc/>
            <Footer/>
            <FooterInfo/>
        </div>
    )
}
